<app-form-page 
    pageTitle="Mail Template" 
    [mode]="mode"
    [allowEditMode]="true"
    [allowNewMode]="false"
    [form]="tForm"
    (modeChanged)="onModeChanged($event)"
    >

    <app-page-command-group>
        <app-page-command name="edit" requiredPermissions="Mail_Action_Template_Edit"></app-page-command>
        <app-page-command name="save" [action]="onSaveClick"></app-page-command>
        <app-page-command name="cancel" [action]="onCancelClick"></app-page-command>
    </app-page-command-group>

    <form (ngSubmit)="onSaveClick()" #tForm="ngForm">
        @if (mailTemplate() !== null) {

            <app-layout-row>
                <app-layout-column [width]="8">
                    <app-textbox [ngModel]="$safeNavigationMigration(mailTemplate()?.DisplayName)" name="DisplayName" caption="Name" [readonly]="true"></app-textbox>
                </app-layout-column>
            </app-layout-row>
            <app-layout-row>
                <app-layout-column [width]="8">
                    <app-textbox [ngModel]="$safeNavigationMigration(mailTemplate()?.Description)" name="Description" caption="Description" [readonly]="true"></app-textbox>
                </app-layout-column>
            </app-layout-row>

            <app-layout-row>
                <app-layout-column [width]="8">
                    <app-toggle-button [ngModel]="selectedButtons()" name="custom" caption="Custom" [buttons]="buttons" (valueChange)="onUseCustomChange($event)"></app-toggle-button>
                </app-layout-column>
            </app-layout-row>

            <div [hidden]="useCustom()===false">
                <app-layout-row>
                    <app-layout-column [width]="8">
                        <app-textbox [ngModel]="$safeNavigationMigration(mailTemplate()?.CustomSubject)" name="CustomSubject" caption="Custom Mail Subject" [required]="useCustom()"></app-textbox>
                    </app-layout-column>
                </app-layout-row>

                <app-layout-row>
                    <app-layout-column [width]="8">
                        <app-html-editor [ngModel]="$safeNavigationMigration(mailTemplate()?.CustomBody)" name="CustomBody" caption="Custom Mail Body Text" [extendedToolbar]="false" [macros]="macros()" height="425px" [required]="useCustom()"></app-html-editor>
                    </app-layout-column>
                </app-layout-row>
            </div>
            <div [hidden]="useCustom()===true">
                <app-layout-row>
                    <app-layout-column [width]="8">
                        <app-textbox [ngModel]="$safeNavigationMigration(mailTemplate()?.Subject)" name="DefaultSubject" caption="Mail Subject" [readonly]="true"></app-textbox>
                    </app-layout-column>
                </app-layout-row>

                <app-layout-row>
                    <app-layout-column [width]="8">
                        <app-html-editor [ngModel]="$safeNavigationMigration(mailTemplate()?.Body)" name="DefaultBody" caption="Mail Body Text" [extendedToolbar]="true" height="425px" [readonly]="true"></app-html-editor>
                    </app-layout-column>
                </app-layout-row>
            </div>
        }
    </form>

</app-form-page>

